<template>
    <div class="weather">
        <div class="container">
            <span>天气情况: </span>
            <img v-if="iconUrl !== undefined && iconUrl !== null && iconUrl !== ''" style="margin-left: 12px;margin-right: 12px;" class="icon" :src="iconUrl" alt="" srcset="">
            <span>气温:{{ weatherList.temp }}°|</span>
            <span>体感温度:{{ weatherList.realFeel }}°|</span>
            <span>湿度:{{ weatherList.humidity }}%|</span>
           
        </div>
        
    </div>
</template>

<script setup>
    import {getWeather} from "@/api/index.js";
    import { ref, onMounted } from 'vue';

    const weatherList = ref({
        updatetime: '',
        temp: '',
        icon: '',
        humidity: '',
        realFeel: ''
    })

    // 拼接icon图片地址
    const iconUrl = ref('')
    // const iconStatus = ref(false)

    // 获取天气信息
    const getWeatherInfo = () => {
        getWeather().then(r => {
            // console.log('r:',r.data)
            if(r.data.code == 1) {
                // console.log('r.data.data:',r.data.data[0]);
                let ref = r.data.data[0];
                if(ref.updatetime) {
                    weatherList.value.updatetime = ref.updatetime;
                }
                if(ref.temp) {
                    weatherList.value.temp = ref.temp;
                }
                if(ref.icon) {
                    weatherList.value.icon = ref.icon;
                }
                if(ref.humidity) {
                    weatherList.value.humidity = ref.humidity;
                }
                if(ref.realFeel) {
                    weatherList.value.realFeel = ref.realFeel;
                }

                // console.log('weatherList:',weatherList.value)

                var _iconUrl = weatherArray.value.filter(r => r.id === parseInt(weatherList.value.icon));
                if(_iconUrl.length < 1) {

                    return false;
                }
                // console.log('_iconUrl:',_iconUrl[0]);
                iconUrl.value = _iconUrl[0].url;

            }
        })
    }

    const weatherArray = ref([
        {id: 0,val: 'W0',url: require('../assets/icon/W0.png')},
        {id: 1,val: 'W1',url: require('../assets/icon/W1.png')},
        {id: 2,val: 'W2',url: require('../assets/icon/W2.png')},
        {id: 3,val: 'W3',url: require('../assets/icon/W3.png')},
        {id: 4,val: 'W4',url: require('../assets/icon/W4.png')},
        {id: 5,val: 'W5',url: require('../assets/icon/W5.png')},
        {id: 6,val: 'W6',url: require('../assets/icon/W6.png')},
        {id: 7,val: 'W7',url: require('../assets/icon/W7.png')},
        {id: 8,val: 'W8',url: require('../assets/icon/W8.png')},
        {id: 9,val: 'W9',url: require('../assets/icon/W9.png')},
        {id: 10,val: 'W10',url: require('../assets/icon/W10.png')},
        {id: 13,val: 'W13',url: require('../assets/icon/W13.png')},
        {id: 14,val: 'W14',url: require('../assets/icon/W14.png')},
        {id: 15,val: 'W15',url: require('../assets/icon/W15.png')},
        {id: 16,val: 'W16',url: require('../assets/icon/W16.png')},
        {id: 17,val: 'W17',url: require('../assets/icon/W17.png')},
        {id: 18,val: 'W18',url: require('../assets/icon/W18.png')},
        {id: 19,val: 'W19',url: require('../assets/icon/W19.png')},
        {id: 20,val: 'W20',url: require('../assets/icon/W20.png')},
        {id: 29,val: 'W29',url: require('../assets/icon/W29.png')},
        {id: 30,val: 'W30',url: require('../assets/icon/W30.png')},
        {id: 31,val: 'W31',url: require('../assets/icon/W31.png')},
        {id: 32,val: 'W32',url: require('../assets/icon/W32.png')},
        {id: 33,val: 'W33',url: require('../assets/icon/W33.png')},
        {id: 34,val: 'W34',url: require('../assets/icon/W34.png')},
        {id: 35,val: 'W35',url: require('../assets/icon/W35.png')},
        {id: 36,val: 'W36',url: require('../assets/icon/W36.png')},
    ])
    
    onMounted(() => {
        getWeatherInfo();
        
        // console.log('onMounted:',weatherArray.value)
        // console.log('onMounted weatherList:',weatherList.value)
    })


</script>

<style scoped>
.weather {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 90%;
    width: 98%;background-color: rgb(255, 255, 255);
    border-radius: 20px;
}
.weather > .container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    font-size: 48px;
}
.icon {
    height: 58px;width: 58px;
}

</style>